export const dataURLtoBlob = (dataUrl) => {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

export const formatFileToBackend = (croppedImage, currentFile) => {
  const blob = !croppedImage ? [currentFile] : [dataURLtoBlob(croppedImage)];
  if (typeof blob[0] === 'string') {
    return blob[0];
  }

  const { name, type } = blob[0];
  return new File(blob, name || `noname.${type.split('/')[1]}`, {
    type,
    lastModified: Date.now(),
  });
};

export const readableBytes = (bytes) => {
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const result = {
    value: (bytes / 1024 ** i).toFixed(2) * 1,
    base: sizes[i],
    message: `${(bytes / 1024 ** i).toFixed(2) * 1} ${sizes[i]}`,
  };
  return result;
};

export const itemsWithConfig = [
  { type: 'Human', name: 'Bloco de Atendimento Humano' },
  { type: 'Collect', name: 'Bloco de Coleta' },
  { type: 'SMS', name: 'Bloco de SMS' },
  { type: 'EMAIL', name: 'Bloco de E-mail' },
  { type: 'VTexAddToCart', name: 'Bloco de Adicionar ao carrinho' },
  { type: 'VTexUpdateCart', name: 'Bloco de Atualizar carrinho' },
  { type: 'VTexRemoveFromCart', name: 'Bloco de Remover item do carrinho' },
  { type: 'VTexCatalogProducts', name: 'Bloco de Listar catálogo' },
  { type: 'VTexOrderList', name: 'Bloco de Listar carrinho' },
  { type: 'VTexCatalogProduct', name: 'Bloco de Buscar produto do catalógo' },
  { type: 'VTexCartProduct', name: 'Bloco de Buscar produto do carrinho' },
  { type: 'VTexCheckout', name: 'Bloco de Checkout' },
  { type: 'ZendeskCreateRequest', name: 'Bloco de Nova Requisição' },
  { type: 'ZendeskListRequests', name: 'Bloco de Listar Requisições' },
  { type: 'ZendeskShowRequest', name: 'Bloco de Mostrar Requisições' },
  { type: 'ZendeskListComments', name: 'Bloco de Listar Comentários' },
  { type: 'ZendeskInsertComment', name: 'Bloco de Inserir Comentário' },
  { type: 'ZendeskAttachFile', name: 'Bloco de Anexar Arquivo' },
  { type: 'ZendeskUpdateStatusRequest', name: 'Bloco de Atualizar Status' },
  { type: 'JiraCreateIssue', name: 'Bloco de Novo Ticket' },
  { type: 'JiraListIssues', name: 'Bloco de Listar Ticket' },
  { type: 'JiraShowIssue', name: 'Bloco de Mostrar Ticket' },
  { type: 'JiraListProjects', name: 'Bloco de Listar Projetos' },
  { type: 'JiraListStatus', name: 'Bloco de Listar Status' },
  { type: 'JiraListRequestypes', name: 'Bloco de Listar Tipos Ticket' },
  { type: 'JiraListPriorities', name: 'Bloco de Listar Prioridades' },
  { type: 'JiraListComments', name: 'Bloco de Listar Comentários' },
  { type: 'JiraInsertComment', name: 'Bloco de Inserir Comentário' },
  { type: 'JiraAttachFile', name: 'Bloco de Anexar Arquivo' },
  { type: 'JiraUpdateStatusIssue', name: 'Bloco de Atualizar Status' },
  { type: 'RdStationInput', name: 'Bloco de Campo' },
  { type: 'RdStationSubmitLead', name: 'Bloco Cria Lead' },
  { type: 'GlpiCreateRequest', name: 'Bloco de Nova Requisição' },
  { type: 'GlpiListRequests', name: 'Bloco de Listar Requisições' },
  { type: 'GlpiShowRequest', name: 'Bloco de Mostrar Requisições' },
  { type: 'GlpiListComments', name: 'Bloco de Listar Comentários' },
  { type: 'GlpiInsertComment', name: 'Bloco de Inserir Comentário' },
  { type: 'GlpiAttachFile', name: 'Bloco de Anexar Arquivo' },
  { type: 'GlpiUpdateStatusRequest', name: 'Bloco de Atualizar Status' },
  { type: 'GlpiListGroups', name: 'Bloco de Listar Grupos' },
];
